import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSettings } from "../context/SettingsContext";
import { useCategories } from "../hooks";

const quickLinks = [
  { label: "Home", href: "#home" },
  { label: "About Us", href: "/about" },
  { label: "Brands", href: "/brands" },
  { label: "Blogs", href: "/all-blogs" },
  { label: "Contact Us", href: "/contact" },
  { label: "FAQ", href: "#faq" },
];

// Social icons map
const SOCIAL_ICONS = {
  youtube: (
    <svg viewBox="0 0 24 24" fill="currentColor" className="w-4 h-4">
      <path d="M23.5 6.2a3 3 0 0 0-2.1-2.1C19.5 3.6 12 3.6 12 3.6s-7.5 0-9.4.5A3 3 0 0 0 .5 6.2C0 8.1 0 12 0 12s0 3.9.5 5.8a3 3 0 0 0 2.1 2.1c1.9.5 9.4.5 9.4.5s7.5 0 9.4-.5a3 3 0 0 0 2.1-2.1C24 15.9 24 12 24 12s0-3.9-.5-5.8zM9.7 15.5V8.5l6.3 3.5-6.3 3.5z" />
    </svg>
  ),
  instagram: (
    <svg viewBox="0 0 24 24" fill="currentColor" className="w-4 h-4">
      <path d="M12 2.2c3.2 0 3.6 0 4.9.1 3.3.1 4.8 1.7 4.9 4.9.1 1.3.1 1.6.1 4.8 0 3.2 0 3.6-.1 4.8-.1 3.2-1.7 4.8-4.9 4.9-1.3.1-1.6.1-4.9.1-3.2 0-3.6 0-4.8-.1-3.3-.1-4.8-1.7-4.9-4.9C2.2 15.6 2.2 15.2 2.2 12c0-3.2 0-3.6.1-4.8C2.4 3.9 4 2.3 7.2 2.3 8.4 2.2 8.8 2.2 12 2.2zm0-2.2C8.7 0 8.3 0 7.1.1 2.7.3.3 2.7.1 7.1 0 8.3 0 8.7 0 12c0 3.3 0 3.7.1 4.9.2 4.4 2.6 6.8 7 7C8.3 24 8.7 24 12 24c3.3 0 3.7 0 4.9-.1 4.4-.2 6.8-2.6 7-7 .1-1.2.1-1.6.1-4.9 0-3.3 0-3.7-.1-4.9C23.7 2.7 21.3.3 16.9.1 15.7 0 15.3 0 12 0zm0 5.8a6.2 6.2 0 1 0 0 12.4A6.2 6.2 0 0 0 12 5.8zm0 10.2a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm6.4-11.8a1.4 1.4 0 1 0 0 2.8 1.4 1.4 0 0 0 0-2.8z" />
    </svg>
  ),
  facebook: (
    <svg viewBox="0 0 24 24" fill="currentColor" className="w-4 h-4">
      <path d="M24 12.1C24 5.4 18.6 0 12 0S0 5.4 0 12.1C0 18.1 4.4 23 10.1 24v-8.4H7.1v-3.5h3V9.4c0-3 1.8-4.7 4.5-4.7 1.3 0 2.7.2 2.7.2v3h-1.5c-1.5 0-1.9.9-1.9 1.9v2.2h3.3l-.5 3.5h-2.7V24C19.6 23 24 18.1 24 12.1z" />
    </svg>
  ),
  twitter: (
    <svg viewBox="0 0 24 24" fill="currentColor" className="w-4 h-4">
      <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
    </svg>
  ),
  linkedin: (
    <svg viewBox="0 0 24 24" fill="currentColor" className="w-4 h-4">
      <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 0 1-2.063-2.065 2.064 2.064 0 1 1 2.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
    </svg>
  ),
  whatsapp: (
    <svg viewBox="0 0 24 24" fill="currentColor" className="w-4 h-4">
      <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413z" />
    </svg>
  ),
};

const SOCIAL_COLORS = {
  youtube: "#FF0000",
  instagram: "#E1306C",
  facebook: "#1877F2",
  twitter: "#000000",
  linkedin: "#0A66C2",
  whatsapp: "#25D366",
};

export default function Footer() {
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();
  const { getLogo, getContact, getSocial } = useSettings();
  const { categories } = useCategories();

  const contact = getContact();
  const social = getSocial();

  const scrollTo = (href) => {
    setMenuOpen(false);
    if (!href.startsWith("#")) {
      navigate(href);
      window.scrollTo({ top: 0 });
      return;
    }
    if (window.location.pathname !== "/") {
      navigate("/");
      setTimeout(() => {
        const el = document.querySelector(href);
        if (el) el.scrollIntoView({ behavior: "smooth" });
      }, 300);
      return;
    }
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  // Active social links
  const activeSocials = Object.entries(social)
    .filter(([, url]) => url)
    .map(([key, url]) => ({ key, url }));

  return (
    <footer className="relative bg-[#101010] text-stone-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 md:px-12 lg:px-20 pt-14 md:pt-20 pb-10">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 md:gap-12">
          {/* Col 1 — Brand */}
          <div className="sm:col-span-2 lg:col-span-1">
            <div className="flex items-center gap-3 mb-5">
              <div className="relative w-14 h-14 flex-shrink-0">
                <img
                  src={getLogo()}
                  className="absolute inset-0 w-full h-full object-contain"
                  alt="FBS logo"
                />
              </div>
              <div>
                <p className="font-display text-[#D0AB55] text-base font-light leading-tight">
                  Franchise
                </p>
                <p className="font-display text-[#D0AB55] text-base font-light leading-tight">
                  Business
                </p>
                <p className="font-display text-[#D0AB55] text-base font-light leading-tight">
                  Solution
                </p>
              </div>
            </div>
            <div className="space-y-2 mt-6">
              {contact.address && (
                <p className="font-body text-stone-400 text-sm">
                  {contact.address}
                </p>
              )}
              {contact.phone && (
                <a
                  href={`tel:${contact.phone}`}
                  className="font-body text-stone-400 text-sm hover:text-gold transition-colors block"
                >
                  {contact.phone}
                </a>
              )}
              {contact.email && (
                <a
                  href={`mailto:${contact.email}`}
                  className="font-body text-stone-400 text-sm hover:text-gold transition-colors block break-all"
                >
                  {contact.email}
                </a>
              )}
            </div>
          </div>

          {/* Col 2 — empty spacer */}
          <div className="hidden lg:block" />

          {/* Col 3 — Categories from API */}
          <div>
            <h4 className="font-body text-white text-sm font-semibold tracking-[0.15em] uppercase mb-5">
              Categories
            </h4>
            <ul className="space-y-3">
              {categories.slice(0, 6).map((cat) => (
                <li key={cat._id}>
                  <button
                    onClick={() => {
                      navigate(`/brands?category=${cat._id}`);
                      window.scrollTo({ top: 0 });
                    }}
                    className="font-body text-stone-400 text-sm hover:text-gold transition-colors duration-200 text-left"
                  >
                    {cat.name}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Col 4 — Quick Links */}
          <div>
            <h4 className="font-body text-white text-sm font-semibold tracking-[0.15em] uppercase mb-5">
              Quick Links
            </h4>
            <ul className="space-y-3">
              {quickLinks.map((link) => (
                <li key={link.label}>
                  <button
                    onClick={() => scrollTo(link.href)}
                    className="font-body text-stone-400 text-sm hover:text-gold transition-colors duration-200 text-left"
                  >
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      {/* Logo watermark */}
      <img
        src={getLogo()}
        className="absolute bottom-0 right-0 w-[300px] h-auto object-contain opacity-10 grayscale pointer-events-none z-0"
        alt=""
      />

      <div className="border-t border-stone-800" />

      <div className="max-w-7xl mx-auto px-4 sm:px-8 md:px-12 lg:px-20 py-5 flex flex-col sm:flex-row items-center justify-between gap-4">
        <p className="font-body text-stone-500 text-xs text-center sm:text-left">
          © {new Date().getFullYear()} Franchise Business Solution. All Rights
          Reserved.{" "}
          <button className="hover:text-gold transition-colors underline underline-offset-2">
            Site Credits.
          </button>
        </p>

        {/* Social icons from API */}
        <div className="flex items-center gap-3">
          {activeSocials.map(
            ({ key, url }) =>
              SOCIAL_ICONS[key] && (
                <a
                  key={key}
                  href={url}
                  target="_blank"
                  rel="noreferrer"
                  aria-label={key}
                  className="w-8 h-8 rounded-full bg-stone-800 hover:bg-stone-700 flex items-center justify-center transition-all duration-200 hover:scale-110"
                  style={{ color: SOCIAL_COLORS[key] || "#fff" }}
                >
                  {SOCIAL_ICONS[key]}
                </a>
              ),
          )}
        </div>
      </div>
    </footer>
  );
}
